(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hl-image-protection"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.hlImageProtection) return;
  window.hlImageProtection = true;
  const images = ':is(.product-images, .hl-image-viewer, .product-list-item-thumbnail, .hl-product-image, .pd-content) img';
  const surfaces = '.product-zoom, .hl-image-viewer__stage, .product-list-item-overlay-link';
  function protect(event) {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    if (event.target.closest(images) || event.target.closest(surfaces)) event.preventDefault();
  }
  document.addEventListener('contextmenu', protect);
  document.addEventListener('dragstart', protect);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-mobile-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    root.querySelectorAll('.hl-mobile-menu').forEach(dialog => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      const header = dialog.closest('[data-section-type="header"]');
      const trigger = header && header.querySelector('.mobile-navigation-toggle');
      if (!trigger) return;
      dialog.dataset.ready = 'true';
      header.classList.add('hl-mobile-menu-ready');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', event => {
        if (!window.matchMedia('(max-width:1020px)').matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('hl-mobile-menu-open');
      }, true);
      dialog.querySelector('.hl-mobile-menu__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right) dialog.close();
        }
        const button = event.target.closest('.hl-mobile-menu__expand');
        if (!button) return;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.firstElementChild.textContent = expanded ? '\u2212' : '+';
        panel.hidden = !expanded;
      });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('hl-mobile-menu-open');
        if (window.matchMedia('(max-width:1020px)').matches) trigger.focus();
      });
      window.matchMedia('(min-width:1021px)').addEventListener('change', event => {
        if (event.matches && dialog.open) dialog.close();
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-recently-viewed"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(root) {
    root.querySelectorAll('[data-hl-recent-products]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const current = section.dataset.handle;
      const storageKey = 'hl-recent-product-handles-v1';
      let previous = [];
      try {
        const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (Array.isArray(stored)) previous = [...new Set(stored.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle) && handle !== current))].slice(0, 12);
        localStorage.setItem(storageKey, JSON.stringify([current, ...previous].slice(0, 12)));
      } catch {}
      if (!previous.length) return;
      const list = section.querySelector('[data-hl-recent-list]');
      const rootUrl = section.dataset.root.replace(/\/?$/, '/');
      const currency = window.Shopify?.currency?.active || section.dataset.currency;
      let money;
      try { money = new Intl.NumberFormat(document.documentElement.lang || undefined, {style: 'currency', currency}); }
      catch { return; }
      async function load() {
        const products = await Promise.all(previous.slice(0, 8).map(async handle => {
          try {
            const response = await fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js');
            if (!response.ok) return null;
            const product = await response.json();
            return product && product.handle === handle && product.featured_image && typeof product.price === 'number' ? product : null;
          } catch { return null; }
        }));
        if (!section.isConnected) return;
        products.filter(Boolean).forEach(product => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'hl-recent-products__card';
          link.href = rootUrl + 'products/' + encodeURIComponent(product.handle);
          const image = document.createElement('img');
          image.className = 'hl-recent-products__image';
          const source = new URL(product.featured_image, location.origin);
          source.searchParams.set('width', '480');
          image.src = source.href;
          image.alt = product.title;
          image.width = 320; image.height = 400; image.loading = 'lazy'; image.decoding = 'async';
          link.appendChild(image);
          for (const [name, text] of [['vendor', product.vendor], ['title', product.title], ['price', (product.price_varies ? section.dataset.from + ' ' : '') + money.format(product.price / 100)]]) {
            const span = document.createElement('span');
            span.className = 'hl-recent-products__' + name;
            span.textContent = text;
            link.appendChild(span);
          }
          item.appendChild(link); list.appendChild(item);
        });
        if (list.children.length) section.hidden = false;
      }
      section.querySelector('[data-hl-recent-prev]').addEventListener('click', () => list.scrollBy({left: -list.clientWidth, behavior: 'smooth'}));
      section.querySelector('[data-hl-recent-next]').addEventListener('click', () => list.scrollBy({left: list.clientWidth, behavior: 'smooth'}));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, {rootMargin: '0px 0px 500px 0px'});
        const anchor = section.parentElement.querySelector('.related-products') || section.parentElement;
        observer.observe(anchor);
      } else load();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.hlMobileImageViewer) return;
  window.hlMobileImageViewer = true;
  const icon = path => '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';
  const arrows = ['M15 5l-7 7 7 7', 'M9 5l7 7-7 7'];
  function initialize(root) {
    root.querySelectorAll('.product-images').forEach(gallery => {
      const trigger = gallery.querySelector('.product-main-image');
      const main = trigger && trigger.querySelector('img');
      if (!main || trigger.classList.contains('hl-viewer-trigger') || !window.HTMLDialogElement) return;
      const thumbnails = Array.from(gallery.querySelectorAll('.product-thumbnails img[data-high-res]')).filter(img => !img.closest('.slick-cloned'));
      const images = thumbnails.length ? Array.from(new Map(thumbnails.map(img => [img.dataset.highRes, {src: img.dataset.highRes, alt: img.alt}])).values()) : [{src: main.currentSrc || main.src, alt: main.alt}];
      trigger.classList.add('hl-viewer-trigger');
      trigger.classList.remove('zoom-active', 'zoom-enabled');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', 'Open product image full screen');
      trigger.setAttribute('aria-haspopup', 'dialog');
      const launch = document.createElement('span');
      launch.className = 'hl-viewer-launch';
      launch.setAttribute('aria-hidden', 'true');
      launch.innerHTML = icon('M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0');
      trigger.appendChild(launch);
      const dialog = document.createElement('dialog');
      dialog.className = 'hl-image-viewer';
      dialog.setAttribute('aria-label', 'Product images');
      dialog.innerHTML = '<div class="hl-image-viewer__layout"><div class="hl-image-viewer__stage"><img class="hl-image-viewer__image" alt="" draggable="false"></div><div class="hl-image-viewer__controls"><button type="button" data-hl-viewer-prev aria-label="Previous image">' + icon(arrows[0]) + '</button><button type="button" data-hl-viewer-close aria-label="Close image viewer">' + icon('M6 6l12 12M18 6L6 18') + '</button><button type="button" data-hl-viewer-next aria-label="Next image">' + icon(arrows[1]) + '</button></div><span class="hl-image-viewer__status" aria-live="polite" aria-atomic="true"></span></div>';
      document.body.appendChild(dialog);
      const stage = dialog.querySelector('.hl-image-viewer__stage');
      const image = dialog.querySelector('img');
      const close = dialog.querySelector('[data-hl-viewer-close]');
      const prev = dialog.querySelector('[data-hl-viewer-prev]');
      const next = dialog.querySelector('[data-hl-viewer-next]');
      const status = dialog.querySelector('[aria-live]');
      prev.hidden = next.hidden = images.length < 2;
      let index = 0, scale = 1, x = 0, y = 0, start = null, pinch = null, lastTap = 0, multiTouch = false;
      const pointers = new Map();
      function transform() {
        x = Math.max(-stage.clientWidth * (scale - 1) / 2, Math.min(stage.clientWidth * (scale - 1) / 2, x));
        y = Math.max(-stage.clientHeight * (scale - 1) / 2, Math.min(stage.clientHeight * (scale - 1) / 2, y));
        image.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ')';
      }
      function reset() { scale = 1; x = y = 0; transform(); }
      function show(i) {
        lastTap = 0;
        index = (i + images.length) % images.length;
        reset();
        image.src = images[index].src;
        image.alt = images[index].alt;
        status.textContent = 'Image ' + (index + 1) + ' of ' + images.length;
      }
      function path(src) { return new URL(src, location.href).pathname.replace(/_\d+x\d*(?=\.)/, ''); }
      function open(event) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (dialog.open) return;
        const current = images.findIndex(item => path(item.src) === path(main.currentSrc || main.src));
        show(current < 0 ? 0 : current);
        dialog.showModal();
        document.documentElement.classList.add('hl-image-viewer-open');
        close.focus({preventScroll: true});
      }
      trigger.addEventListener('click', open, true);
      trigger.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') open(event); });
      close.addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('hl-image-viewer-open');
        pointers.clear(); start = pinch = null; reset();
        if (trigger.isConnected) trigger.focus({preventScroll: true});
      });
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      stage.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
        stage.setPointerCapture(event.pointerId);
        if (pointers.size === 1) { multiTouch = false; start = {x: event.clientX, y: event.clientY, panX: x, panY: y}; }
        else if (pointers.size === 2) {
          multiTouch = true;
          const [a, b] = Array.from(pointers.values());
          pinch = {distance: Math.hypot(a.x - b.x, a.y - b.y), scale};
        }
      });
      stage.addEventListener('pointermove', event => {
        if (!pointers.has(event.pointerId)) return;
        pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
        if (pointers.size === 2 && pinch) {
          const [a, b] = Array.from(pointers.values());
          scale = Math.min(4, Math.max(1, pinch.scale * Math.hypot(a.x - b.x, a.y - b.y) / Math.max(1, pinch.distance)));
          transform();
        } else if (scale > 1 && start && !multiTouch) {
          x = start.panX + event.clientX - start.x; y = start.panY + event.clientY - start.y; transform();
        }
      });
      stage.addEventListener('pointerup', event => {
        pointers.delete(event.pointerId);
        if (!start || multiTouch) { if (!pointers.size) start = pinch = null; return; }
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (scale === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
        else if (Math.hypot(dx, dy) < 12) {
          const now = Date.now();
          if (now - lastTap < 320) { scale = scale > 1 ? 1 : 2.5; x = y = 0; transform(); lastTap = 0; }
          else lastTap = now;
        }
        start = pinch = null;
      });
      stage.addEventListener('pointercancel', () => { pointers.clear(); start = pinch = null; });
      stage.addEventListener('wheel', event => { if (!event.ctrlKey && !event.metaKey) return; event.preventDefault(); scale = Math.min(4, Math.max(1, scale - event.deltaY * 0.005)); transform(); }, {passive: false});
    });
  }
  // theme.js swaps the main image by setting src only; drop the responsive srcset so the swap shows.
  function keepSwapsVisible(root) {
    root.querySelectorAll('.product-main-image img[srcset]').forEach(img => {
      new MutationObserver((records, observer) => { img.removeAttribute('srcset'); img.removeAttribute('sizes'); observer.disconnect(); }).observe(img, {attributes: true, attributeFilter: ['src']});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { keepSwapsVisible(document); initialize(document); });
  else { keepSwapsVisible(document); initialize(document); }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
